import Vue from 'vue'
import { EagleModule } from 'kernel/types/module'

class moduleIndex {
  private vm: Vue| undefined
  public name: string
  constructor() {
    this.name = 'store'
  }

  public initVue(vm: Vue) {
    this.vm = vm
  }

  async launch(vm: Vue) : Promise<void>{

  }

  getModuleConfig() : EagleModule {
    return {
      launch: this.launch,
      menu: () => import('modules/store/config/menu'),
      realApi: () => import('modules/store/config/realApi'),
      routes: () => import('modules/store/config/route'),
    }
  }
}

export default new moduleIndex()
